import Model  from "./base/model";

class AuditsOrder extends Model{
  resourceName() {
    return "audits_order";
  }

  fields() {
    return {
      id: "",
      order_id: "",
      audit: "",
      result: "",
      manual_approved: "",
      justification: "",
      name: "",
      path: "",
      is_addition: "",
      value: "",
    }
  }

}

export default new AuditsOrder();
